import { useQuery } from '@tanstack/react-query'
import { useManualQuery } from 'graphql-hooks'
import { getWizardDepartmentData } from '../../graphql/custom-queries'
import { queryKeys } from '../tanstack-query/queryClient'
import type { IOnboardingDepartment } from '../../components/onboarding-wizard/types'

interface WizardDepartmentApiResult {
  getTeamList: Array<{ id: string; name: string; isDefault: boolean }>
}

const mapWizardDepartments = (data: WizardDepartmentApiResult): IOnboardingDepartment[] => {
  const defaultDept = data.getTeamList.find((t) => t.isDefault)
  if (!defaultDept) return []
  return [
    {
      id: defaultDept.id,
      name: defaultDept.name,
      isDefault: true,
      initialName: defaultDept.name,
    },
  ]
}

export const useWizardDepartmentInit = (enabled: boolean) => {
  const [getDepartmentData] = useManualQuery<WizardDepartmentApiResult>(getWizardDepartmentData)

  return useQuery({
    queryKey: queryKeys.onboarding.wizardDepartments(),
    enabled,
    staleTime: Infinity,
    retry: false,
    queryFn: async (): Promise<IOnboardingDepartment[]> => {
      const response = await getDepartmentData()
      if (!response.data || response.error) throw response.error
      return mapWizardDepartments(response.data)
    },
  })
}
